import { setCurrentCart } from '../../VNCustomerFacingDisplay/ActionCreators'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { getCartTotalsUuid, getCFDScreen } from '../../VNCustomerFacingDisplay/Selectors'
import { sendCFDScreenNav } from '../bridgeCalls/VNWebSDKDataSend'

const ACCEPTABLE_SCREENS = {
  [CFD_SCREEN.IDLE]: [CFD_SCREEN.IDLE],
  [CFD_SCREEN.CART]: [CFD_SCREEN.CART],
  [CFD_SCREEN.CARD_PAYMENT]: [CFD_SCREEN.CARD_PAYMENT, CFD_SCREEN.CHARITY, CFD_SCREEN.CARD_DECLINED, CFD_SCREEN.RECEIPT],
}

export const processCFDScreenNav = (response, dispatch, getState) => {
  const curState = getState()
  const savedScreen = getCFDScreen(curState)

  if (
    response.data.cartTotalsUuid &&
    ACCEPTABLE_SCREENS[CFD_SCREEN.CARD_PAYMENT]?.includes(response.data?.screen) &&
    ACCEPTABLE_SCREENS[savedScreen]?.includes(savedScreen)
  ) {
    const a3700CartTotalsUuid = response.data.cartTotalsUuid
    const localCartTotalsUuid = getCartTotalsUuid(curState)

    if (a3700CartTotalsUuid !== localCartTotalsUuid) {
      setCurrentCart({})
      sendCFDScreenNav(CFD_SCREEN.IDLE)
    }
  }

  if (ACCEPTABLE_SCREENS[savedScreen]?.includes(response.data?.screen) && !response.data.cartTotalsUuid) {
    sendCFDScreenNav(response.data.screen)
    return
  }

  if (response.data?.screen === CFD_SCREEN.PROCESSING) {
    sendCFDScreenNav(CFD_SCREEN.IDLE)
    return
  }

  if (savedScreen === response.data?.screen) {
    sendCFDScreenNav(response.data.screen)
    return
  }

  sendCFDScreenNav(CFD_SCREEN.IDLE)
}
